import { render } from "./PrivacyPolicy.vue?vue&type=template&id=6b4b6b4c"
import script from "./PrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicy.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/dmp/releases/1776447368/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__